import * as React from 'react';
import { InputProps } from '@material-ui/core/Input';
import { withUser, WithUser } from '../HOC/User';
import { Redirect, withRouter, RouteComponentProps } from 'react-router';
import { List, createStyles, WithStyles, withStyles, ListItem, ListItemText, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import strings from 'src/strings';
import { PaymentsAPI, APIError, APIErrorType } from 'src/api';
import KDGlobal from '../Global';
import { withToast, WithToast } from '../HOC/Toast';

interface EditSubscriptionProps {
    onLoading: (loading: boolean) => void
    className?: string;
}

class EditSubscription extends React.Component<EditSubscriptionProps & WithUser<true> & WithStyles<typeof styles> & RouteComponentProps & WithToast,
    { cancelDialog: boolean, loading: boolean }> {

    constructor(props: EditSubscriptionProps & WithUser<true> & WithStyles<typeof styles> & RouteComponentProps & WithToast) {
        super(props);
        this.state = {
            cancelDialog: false, loading: false
        }
    }

    private showCancelPopup() {
        this.setState({ cancelDialog: true })
    }

    private cancelSubscription(now: boolean) {
        this.props.onLoading(true)
        this.setState({ loading: true, cancelDialog: false })
        PaymentsAPI.cancel(now).then(user => {
            this.props.onLoading(false)
            this.setState({ loading: false })
            KDGlobal.instance.setUser(user);
            sessionStorage['cancelMembership'] = 'true'
            this.props.history.push('/app/dashboard')
        }).catch((err: APIError) => {
            this.props.onLoading(false)
            this.setState({ loading: false })
            if (err.type == APIErrorType.NotAccessibleError) {
                this.props.showToast('error', strings.cancel_novalidSusbcriptionFound)
            } else {
                this.props.showToast('error', strings.error_generic)
            }
        })
    }

    public render() {
        if (!this.props.user.hasValidSubscription()) {
            return <Redirect to={'/pricing'} />
        }
        const { classes } = this.props
        return (
            <div className={this.props.className}>
                <List className={classes.root}>
                    <ListItem>
                        <ListItemText primary={strings.info_currentSubscription} secondary={this.props.user.getValidSubscription()!.package.name} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={strings.upgrade} secondary={strings.upgrade_subTitle} />
                        <Button variant='outlined' className={classes.actionButton} disabled={this.state.loading}
                            onClick={(e) => this.props.history.push('/pricing')}>
                            {strings.upgrade}
                        </Button>
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={strings.cancel_membership} secondary={strings.cancel_membershipSubTitle} />
                        <Button variant='outlined' color='secondary' className={classes.actionButton} disabled={this.state.loading}
                            onClick={(e) => this.showCancelPopup()}>
                            {strings.cancel}
                        </Button>
                    </ListItem>
                </List>
                <Dialog
                    open={this.state.cancelDialog}
                    aria-labelledby="cancel-dialog-title"
                    aria-describedby="cancel-dialog-description">
                    <DialogTitle id="cancel-dialog-title">{strings.cancel_membership}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="cancel-dialog-description">
                            {strings.cancel_membershipDescription}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant='outlined' color='secondary' onClick={(e) => { this.cancelSubscription(true) }}>
                            {strings.cancel_now}
                        </Button>
                        <Button variant='outlined' color='secondary' onClick={(e) => { this.cancelSubscription(false) }}>
                            {strings.cancel_atNextRenewal}
                        </Button>
                        <Button color="primary" autoFocus variant='contained' onClick={(e) => this.setState({ cancelDialog: false })}>
                            {strings.no}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

const styles = createStyles({
    root: {
        width: '100%',
    },
    actionButton: {
        float: 'right'
    }
})

export default (withToast(withRouter(withStyles(styles)(withUser(EditSubscription, true)))) as React.ComponentClass<EditSubscriptionProps>)


// WEBPACK FOOTER //
// ./src/components/ManageSubscription/EditSubscription.tsx